"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_Withdraw_cash_atm_hi__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Apps_ic",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 192 192",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-10,.cls-5{fill:none;}.cls-2{fill:#fff;}.cls-3,.cls-8{opacity:0.06;}.cls-4{fill:#ebebeb;}.cls-5{stroke:#ccc;stroke-width:0.5px;}.cls-10,.cls-5{stroke-linecap:round;stroke-linejoin:round;}.cls-6{fill:#f4f4f4;}.cls-7{fill:#ccc;}.cls-9{fill:#afafaf;opacity:0.5;}.cls-10{stroke:#e10003;stroke-width:8px;}.cls-11{opacity:0.2;isolation:isolate;fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 68.04,
    y1: -417.04,
    x2: 152.33,
    y2: -501.34,
    gradientTransform: "matrix(1, 0, 0, -1, 0, -402.39)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("title", null, "Withdraw_cash_atm_hi-dark"), /*#__PURE__*/React.createElement("g", {
    id: "Apps_ic_hi"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding_Box",
    "data-name": "Bounding Box",
    className: "cls-1",
    width: 192,
    height: 192
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Bounding_Box-2",
    "data-name": "Bounding Box",
    className: "cls-1",
    width: 192,
    height: 192
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Bounding_Box-3",
    "data-name": "Bounding Box",
    className: "cls-1",
    width: 192,
    height: 192
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M151.84,39.15a7,7,0,0,1,2.06,5V94.48a7,7,0,0,1-7,7H45.1a7,7,0,0,1-7-7V44.15a7,7,0,0,1,2.06-5Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M146.9,99.48H45.1a7,7,0,0,1-7-7v2a7,7,0,0,0,7,7H146.9a7,7,0,0,0,7-7v-2A7,7,0,0,1,146.9,99.48Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M59.75,89.48a9.7,9.7,0,0,0-9.7-9.7v-21a9.7,9.7,0,0,0,9.7-9.7h72.41a9.7,9.7,0,0,0,9.7,9.7v21a9.7,9.7,0,0,0-9.7,9.7Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M59.75,89.48a9.7,9.7,0,0,0-9.7-9.7v-21a9.7,9.7,0,0,0,9.7-9.7h72.41a9.7,9.7,0,0,0,9.7,9.7v21a9.7,9.7,0,0,0-9.7,9.7Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 95.95,
    cy: 69.28,
    r: 11.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M96,59.92A11.35,11.35,0,0,0,84.65,70.28c0-.33-.05-.66-.05-1a11.36,11.36,0,1,1,22.71,0c0,.34,0,.67,0,1A11.35,11.35,0,0,0,96,59.92Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M59.75,51.08h72.41a9.7,9.7,0,0,0,9.7,9.7v-2a9.7,9.7,0,0,1-9.7-9.7H59.75a9.7,9.7,0,0,1-9.7,9.7v2A9.7,9.7,0,0,0,59.75,51.08Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M151.84,44.58a7,7,0,0,1,2.06,5v10l.1.36h10.91a7,7,0,0,0,7-7V27h0a7,7,0,0,0-7-7H27.09a7,7,0,0,0-7,7V53a7,7,0,0,0,7,7H37.77l.33-.36v-10a7,7,0,0,1,2.06-5Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.91,58.36H154l-.1-.35v2l.1.35h10.91a7,7,0,0,0,7-7v-2A7,7,0,0,1,164.91,58.36Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.09,58.36a7,7,0,0,1-7-7v2a7,7,0,0,0,7,7H37.77L38.1,60V58l-.33.35Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M153.9,47.58a7,7,0,0,0-2.06-5H40.16a7,7,0,0,0-2.06,5v2a7,7,0,0,1,2.06-5H151.84a7,7,0,0,1,2.06,5Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 95.98,
    y1: 117.39,
    x2: 95.98,
    y2: 170.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 95.98,
    y1: 170.19,
    x2: 77.48,
    y2: 150.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M96,115.41a4,4,0,0,1,4,4v-1.79a4.14,4.14,0,0,0-3.64-4.19,4,4,0,0,0-4.36,4v2A4,4,0,0,1,96,115.41Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M74.76,149.28a4,4,0,0,1,5.65.21L92,162v-2L80.41,147.53a4,4,0,0,0-6.79,3.7A3.91,3.91,0,0,1,74.76,149.28Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 114.49,
    y1: 150.26,
    x2: 95.98,
    y2: 170.19
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M118.35,151.23a4,4,0,0,0-6.79-3.7L100,160v2l11.58-12.51a4,4,0,0,1,5.65-.21A3.91,3.91,0,0,1,118.35,151.23Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M40.1,42.58,99,101.48H146.9a7,7,0,0,0,7-7V47.58a7,7,0,0,0-2.06-5Z",
    transform: "translate(0 0)"
  })));
}

var _default = ic_Withdraw_cash_atm_hi__dark;
exports.default = _default;